import { render, staticRenderFns } from "./ButtonAddToCart.vue?vue&type=template&id=3fb36e78&scoped=true&"
import script from "./ButtonAddToCart.vue?vue&type=script&lang=js&"
export * from "./ButtonAddToCart.vue?vue&type=script&lang=js&"
import style0 from "./ButtonAddToCart.vue?vue&type=style&index=0&id=3fb36e78&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fb36e78",
  null
  
)

export default component.exports